import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { filterDuplicates, Minute, RuntimeModules, sortArray } from '@nu-art/ts-common';
import './ATS_ConflictResolution.scss';
import { ATS_Backend, Button, ComponentSync, LL_V_L, SimpleListAdapter, TS_DropDown, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_CollectionActions } from '@nu-art/thunderstorm-frontend/modules/ModuleFE_CollectionActions';
import { ModuleFE_ConflictResolution } from '../../_modules/ModuleFE_ConflictResolution.js';
export class ATS_ConflictResolution extends ComponentSync {
    static screen = {
        name: 'Conflict Resolution',
        key: 'conflict-resolution',
        renderer: this,
        group: ATS_Backend,
    };
    deriveStateFromProps(nextProps, state) {
        state.upgradableModules ??= sortArray(filterDuplicates(RuntimeModules().filter((module) => {
            return !!module.getCollectionName;
        }), (module) => module.getCollectionName()), item => item.getCollectionName());
        return state;
    }
    getAdapter = () => {
        return SimpleListAdapter(this.state.upgradableModules, module => _jsx(_Fragment, { children: module.item.dbDef.dbKey }));
    };
    checkUsage = async () => {
        const itemId = this.state.itemId;
        const dbKey = this.state.selectedModule?.dbDef.dbKey;
        if (!itemId || !dbKey)
            return;
        const response = await ModuleFE_CollectionActions.check.usage({
            dbKey: dbKey,
            itemIds: [itemId]
        }).setTimeout(2 * Minute).executeSync();
        if (response.dependencies)
            ModuleFE_ConflictResolution.showDependencies(response.dependencies);
    };
    render() {
        const adapter = this.getAdapter();
        return _jsxs(LL_V_L, { id: 'page__check-usage', children: [_jsx(TS_PropRenderer.Vertical, { label: 'Collection', children: _jsx(TS_DropDown, { adapter: adapter, selected: this.state.selectedModule, onSelected: module => this.setState({ selectedModule: module }) }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Item ID', children: _jsx(TS_Input, { type: 'text', value: this.state.itemId, onChange: val => this.setState({ itemId: val }) }) }), _jsx(Button, { onClick: this.checkUsage, children: "Check Usage" }, 'upgrade-all-test')] });
    }
}
//# sourceMappingURL=ATS_ConflictResolution.js.map